import React, { useEffect, useState } from 'react';
import { Modal } from 'react-responsive-modal';
import { MasterMessage } from '../../../masters/masterMessages';
import ListView from '../../components/views/listView';
import { asyncGetHistorical } from '../../../services/caseReport.service';
import moment from 'moment/moment';

type Props = {
    open: boolean;
    onClose: (value: boolean) => void;
    numberId: string;
};

const ModalHistorical = ({ open, onClose, numberId }: Props) => {
    const { titleModal } = MasterMessage.caseReport;
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(20);
    const [rows, setRows] = useState<any>();
    const [lengthRows, setLengthRows] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        asyncGetHistorical(numberId)
            .then((body: any) => {
                if (body.items !== undefined) {
                    setRows(
                        body.items.items.length > 0 ? body.items.items : []
                    );
                    setLengthRows(
                        body.items.length.length > 0 ? body.items.items : 0
                    );
                    setLoading(false);
                }
            })
            .catch(() => setLoading(false));
    }, [numberId]);

    const columns = [
        {
            field: 'Documento',
            headerName: 'Documento',
            minWidth: 80,
            flex: 1,
        },
        {
            field: 'Caso cosmos',
            headerName: 'Caso cosmos',
            minWidth: 120,
            flex: 1.5,
        },
        {
            field: 'Canal',
            headerName: 'Canal',
            minWidth: 80,
            flex: 1,
        },
        {
            field: 'Descripción',
            headerName: 'Descripción',
            minWidth: 150,
            flex: 2,
        },
        {
            field: 'Tipo',
            headerName: 'Tipo',
            minWidth: 80,
            flex: 1,
        },
        {
            field: 'Proceso inicial',
            headerName: 'Proceso inicial',
            minWidth: 100,
            flex: 1,
        },
        {
            field: 'Tipificación',
            headerName: 'Tipificación',
            minWidth: 100,
            flex: 1,
        },
        {
            field: 'Sub tipificación',
            headerName: 'Sub Tipificación',
            minWidth: 100,
            flex: 1,
        },
        {
            field: 'Tipificación hija',
            headerName: 'Tipificación hija',
            minWidth: 100,
            flex: 1,
        },
        {
            field: 'Fecha de creación',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 1,
            type: 'dateTime',
            valueFormatter: (params: any) =>
                params?.value !== null
                    ? moment(params?.value).format('DD/MM/YYYY hh:mm:ss A')
                    : null,
        },
    ];

    const paginator = (paginationModel: any) => {
        if (paginationModel.page !== page) {
            setPage(paginationModel.page);
        } else if (paginationModel.pageSize !== pageSize) {
            setPageSize(paginationModel.pageSize);
        }
    };

    return (
        <Modal
            open={open}
            onClose={() => onClose(false)}
            styles={{ modal: { minWidth: '90%' } }}
            classNames={{ root: 'modal-case-mr' }}
        >
            <ListView
                title={titleModal}
                disableAdd={true}
                disableBack={true}
                columns={columns}
                rows={rows}
                rowCount={lengthRows}
                disableRow={true}
                loading={loading}
                onSetPage={(paginationModel: any) => paginator(paginationModel)}
                getRowHeight="auto"
            />
        </Modal>
    );
};

export default ModalHistorical;
